module.exports = __webpack_public_path__ + "img/旭瑞雨情自动遥测信息化应用软件V1.0.a05df1b8.jpg";